// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2y6tl","cell":"ColumnAccessor_cell__3rK20","firstCellAccent":"ColumnAccessor_firstCellAccent__1SL2h"};